import { render, staticRenderFns } from "./VoiceExport.vue?vue&type=template&id=2ee36b80&"
import script from "./VoiceExport.vue?vue&type=script&lang=js&"
export * from "./VoiceExport.vue?vue&type=script&lang=js&"
import style0 from "./VoiceExport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports